




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { auth } from '@/firebaseConfig.ts';

@Component
export default class AppSidebar extends Vue {
  currentUser: firebase.User | null = auth.currentUser;

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }
  mounted() {}
}
